(function ($) {
    $(document).ready(function () {
        function updateSelectBox() {
            $.ajax({
                url: '/wp-json/dalby-firewood/v1/update-delivery-date',
                type: 'POST',
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', woocommerceDeliveryDate.nonce );
                },
                success: function (data) {
                    var selectBox = $('#woo_delivery_date');

                    // Clear existing options
                    selectBox.empty();

                    // Add new options
                    $.each(data, function (index, option) {
                        // if (dalby.isAdmin || dalby.isAdminAsCustomer) {
                        //     if ('0' === index) {
                        //         option = 'No specific date';
                        //     }
                        // } else {
                        //     if ('0' === index) {
                        //         index = '';
                        //     }
                        // }
                        selectBox.append($('<option></option>').attr('value', index).text(option));
                    });
                },
                error: function (error) {
                    console.log(error);
                }
            });
        }

        function checkDeliveryValidation() {

            delivery_validation = dalby.validationMessages['deliveryValidation'];

            if ($('.woocommerce-error li').length !== 0) {
                if ($('.woocommerce-error li').text().trim() === delivery_validation.trim()) {
                    updateSelectBox();
                }
            }
        }

        function handleMutations(mutationsList, observer) {
            // Check for specific elements or conditions
            checkDeliveryValidation();
        }

        // Create a MutationObserver with a callback function
        var observer = new MutationObserver(handleMutations);

        // Configuration for the observer (you can adjust this as needed)
        var config = { childList: true, subtree: true };

        // Start observing the entire document for changes
        observer.observe(document, config);
    });
})(jQuery);